import React, { useMemo } from "react";

import TabHeader from "./TabHeader";
import { Tab, TabContent, TabPane } from "react-bootstrap";
import Page from "./Page";

/**
 * Custom tabs component implementation.
 */
const Tabs = (props) => {
  return useMemo(
    () => (
      <Tab.Container activeKey={props.selectedPage} onSelect={(eventKey) => props.changeSelectedPage(eventKey)}>
        <TabHeader {...props} />
        <TabContent className="border border-primary">
          {props.pages.map((page, key) => (
            <TabPane key={key} eventKey={page.name}>
              <Page {...props} page={page} title={page.title ? page.title : page.name} />
            </TabPane>
          ))}
        </TabContent>
      </Tab.Container>
    ),
    [props]
  );
};

export default Tabs;
